import { createAsyncThunk } from "@reduxjs/toolkit";

export const asyncThunkHandler = <T, R> (
    typePrefix: string,
    handler: (props: T) => Promise<R>,
) => 
    createAsyncThunk(typePrefix, async (props: T, { rejectWithValue }) => {
        try {
            const response = await handler(props);

            // console.log("AsyncThunk Response:", { typePrefix, response });

            return response;
        } catch (error) {
            return rejectWithValue(error as any);
        }
    });